import http from "./httpService";

const apiEndpoint = process.env.REACT_APP_API_PROSPECTSALESTOOL_URL + "/markets";
const apiEndpointLanguage = process.env.REACT_APP_API_PROSPECTSALESTOOL_URL + "/Common";
export async function GetMarkets(userId) {
  let id = userId?userId:undefined
  http.addBearerAuthorization();
  return await http.post(`${apiEndpoint}/GetMarketsByUser${id?"?userId="+id:"?"}`);
}
export async function GetMarketsByScreen(screen) {
  http.addBearerAuthorization();
  return await http.post(`${apiEndpoint}/GetMarketsByUserScreen?screen=${screen}`);
}

export async function GetMarket(market_id) {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/" + encodeURIComponent(market_id));
}

export async function GetLanguage(market_id) {
  http.addBearerAuthorization();
  return await http.get(apiEndpointLanguage + "/" + encodeURIComponent(market_id));
}

export default {
  GetMarkets,
  GetMarketsByScreen,
  GetMarket,
  GetLanguage
};
